import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  GetEnumValuesDto,
  GetPeriodicSmartSmsRequestStatisticsDto,
  SmartSmsStatisticsByRequestIdRecipientIdItem,
  SmartSmsStatisticsDailyDeliveryCountResult,
} from 'src/app/core/api/models';
import { SmartSmsRequestsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ClientDataInitializerService } from 'src/app/core/services/authentication/client-data-initializer.service';
import { ConsoleService } from 'src/app/core/services/console.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { TranslationService } from '../../../../i18n/translation.service';

@Component({
    selector: 'app-send-details-stats',
    templateUrl: './send-details-stats.component.html',
    styleUrls: ['./send-details-stats.component.scss'],
    standalone: false
})
export class SendDetailsStatsComponent
  extends BaseFormPageComponent
  implements OnInit
{
  initForm(): void {
    throw new Error('Method not implemented.');
  }

  @Input('data') data: chartsPageModel = {
    filters: { SmartSmsRequestId: 0, StartDateTime: '', EndDateTime: '' },
    model: [],
    title: '',
  };
  @Output('closeCharts') closeCharts = new EventEmitter<boolean>();

  fields = 'pages.sendSmartSms.form.fields.';

  items: Array<GetPeriodicSmartSmsRequestStatisticsDto>;

  StatisticsSendStatusEnumValues: GetEnumValuesDto[] = [];
  MobileOperatorEnumValues: GetEnumValuesDto[] = [];
  PersianMonthEnumValues: GetEnumValuesDto[] = [];
  loading: boolean = true;
  barChartItems: SmartSmsStatisticsDailyDeliveryCountResult[] = [];
  dateType: string = '';
  totalSmsCount: number;
  totalPartsCount: number;
  protected onDestroy$ = new Subject<void>();

  constructor(
    protected clientDataService: ClientDataInitializerService,
    protected smartSmsRequestsService: SmartSmsRequestsService,
    protected translationService: TranslationService
  ) {
    super();
  }

  ngOnInit() {
    try {
      this.getEnumsValues();
      //   this.onLoadBarChartData();
    } catch (error) {
      this.loggerService.logError(
        'app-send-details-stats',
        error,
        EventTypes.smartSms
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      ConsoleService.info('data', this.data);

      this.items = this.data.model;
      this.totalPartsCount = this.items
        .map((item) => item.partsCount)
        .reduce((acc, curr) => {
          return acc + curr;
        }, 0);

      this.totalSmsCount = this.items
        .map((item) => item.smsCount)
        .reduce((acc, curr) => {
          return acc + curr;
        }, 0);
      this.onLoadBarChartData();
      this.title = this.data.title.replaceAll('+', ' ');
    }
  }

  // onClose() {
  //   this.closeCharts.emit(false);
  // }

  getEnumsValues() {
    try {
      const timeOut = setTimeout(() => {
        this.getEnumValuesApi('PersianMonth')
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((values) => {
            this.PersianMonthEnumValues = values;
            clearTimeout(timeOut);
          });

        this.getEnumValuesApi('StatisticsSendStatus')
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((values) => {
            this.StatisticsSendStatusEnumValues = values;
            clearTimeout(timeOut);
          });

        this.getEnumValuesApi('SmsAggregator')
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((values) => {
            this.MobileOperatorEnumValues = values;
            clearTimeout(timeOut);
          });
      }, 200);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.statisticalReports
      );
    }
  }

  onPrint() {
    window.print();
  }

  onLoadBarChartData() {
    this.unSubs();
    this.smartSmsRequestsService
      .smartSmsRequestsGetSmartSmsStatisticsDailyOrMonthlyDeliveryCount({
        SmartSmsRequestId: this.data.filters.SmartSmsRequestId,
        StartDateTime: this.data.filters.StartDateTime,
        EndDateTime: this.data.filters.EndDateTime,
      })
      .subscribe((res) => {
        this.barChartItems = res?.data;
        if (
          res?.data?.find((a) => a.persianDay != null || a.persianMonth != null)
            ?.persianDay == null
        )
          this.dateType = 'monthly';
        else this.dateType = 'daily';
      });
  }
}
interface chartsPageModel {
  filters: {
    SmartSmsRequestId: number;
    StartDateTime: string;
    EndDateTime: string;
  };
  model: SmartSmsStatisticsByRequestIdRecipientIdItem[];
  title: string;
}
